module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container PaymentdetailsAdd"
  }, [_c('form', {
    staticClass: "h-adr"
  }, [_c('p', {
    staticClass: "m-label"
  }, [_vm._v("新規追加")]), _vm._v(" "), _c('paymentdetail-form', {
    attrs: {
      "paymentdetail": _vm.paymentdetail,
      "watch": _vm.watch
    }
  }), _vm._v(" "), _c('btn', {
    staticClass: "u-btn u-btn--add",
    nativeOn: {
      "click": function($event) {
        return _vm.postPaymentdetail($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-contract-plus"
  }), _vm._v("paymentdetailを新規追加")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08272176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Paymentdetails/PaymentdetailsAdd.vue
// module id = 1283
// module chunks = 0